import {
  makeStyles,
  Snackbar,
  TextField,
} from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import React, {  useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";

import BCService from "../../services/BC";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";


const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 500,
    height: 300,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
    },
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },

  cancelAndAddButtom: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const RejeterPayement = ({ idPayementInfo, setOnRejeterPayement }) => {


  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [dateRejet, setDateRejet] = useState();
  const [name, setName] = useState();
  const [desc, setDesc] = useState();
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeDesc = (event) => {
    setDesc(event.target.value);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnRejeterPayement(false);
  };

  const onAddBrand = () => {

      let payementModel = {
        idPayementInfo: idPayementInfo,
        description: desc,
        dateRejet: dateRejet,
        idUserCreation: getCurrentUserId(),
        typePayement: "refuse",
      };
      BCService.PayRejeterPayementInfo(payementModel)
      .then((response) => {
        if (response.data["error"]) {
          toast.error("Error : il ya un probléme");
        } else {
          toast.success("ajouté avec succès");
          window.location.reload(false);

          // this.refreshPage();
        }
      })
      .catch((error) => {
        toast.error("Error : il ya un probléme");
        window.location.reload(false);

        // this.refreshPage();
      });
    
  };

  const changeDateRejet = (event) => {
    setDateRejet(event.target.value.concat(":59"))
  }

  return (
    <>
      <div class="modal fade" id="rejeter-payement">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">Rejeter le payement</h4>
            </div>
            <div class="modal-body">


              <div className="row">
                <div className="form-group col-sm-12">
                  <label>Date Opération </label>
                  <br />
                  <TextField
                    style={{ width: "100%" }}
                    className="col-sm-12"
                    variant="outlined"
                    value={dateRejet}
                    onChange={changeDateRejet}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    size="small"
                  />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12">
                  <label htmlFor="inputDescription">Note</label>
                  <textarea
                    placeholder="Saisir..."
                    onChange={onChangeDesc}
                    id="inputDescription"
                    className="form-control"
                    rows={2}
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button type="button" onClick={onAddBrand} class="btn btn-light">
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={openAlert}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default RejeterPayement;
